class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.mainBtn = document.querySelector('.js-add-to-cart');
    this.triggerBtn = this.querySelector('.js-trigger-add');
    this.priceText = this.querySelector('.js-sticky-price');
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    if (this.triggerBtn) {
      this.triggerBtn.addEventListener('click', () => {
        this.mainBtn.click();
      });
    }

    window.addEventListener('scroll', () => {
      this.appear();
    });

    window.addEventListener('sticky-price-change', (event) => {
      this.priceText.textContent = event.detail.price;
    });
  }

  appear() {
    if (!this.mainBtn) return;

    const rect = this.mainBtn.getBoundingClientRect();

    if (rect.top <= 0) {
      this.classList.add('appear');
    } else {
      this.classList.remove('appear');
    }
  }
}

customElements.define('sticky-atc', StickyAddToCart);
